import { render } from "./ActionConfirm.vue?vue&type=template&id=5e6ed654&scoped=true"
import script from "./ActionConfirm.vue?vue&type=script&lang=js"
export * from "./ActionConfirm.vue?vue&type=script&lang=js"

import "./ActionConfirm.vue?vue&type=style&index=0&id=5e6ed654&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6ed654"]])

export default __exports__